import {TEXTAREA_DEFAULT_MAX} from '../../utils/constants';

type WordCountProps = {
  count: number;
  maxLength?: number;
};
export function WordCount({count, maxLength}: WordCountProps) {
  return (
    <span>
      {count}/{maxLength ?? TEXTAREA_DEFAULT_MAX}
    </span>
  );
}
